import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    adsbygoogle?: Record<string, unknown>[];
  }
}

type AdPlacement = 'home' | 'listing' | 'articleTop' | 'articleBottom';

interface AdSenseAdProps {
  placement: AdPlacement;
  className?: string;
}

const PUBLISHER_ID = 'ca-pub-2153789018895115';

const slots: Record<AdPlacement, string | undefined> = {
  home: import.meta.env.VITE_ADSENSE_SLOT_HOME,
  listing: import.meta.env.VITE_ADSENSE_SLOT_LISTING,
  articleTop: import.meta.env.VITE_ADSENSE_SLOT_ARTICLE_TOP,
  articleBottom: import.meta.env.VITE_ADSENSE_SLOT_ARTICLE_BOTTOM,
};

export default function AdSenseAd({ placement, className = '' }: AdSenseAdProps) {
  const initialized = useRef(false);
  const slot = slots[placement]?.trim();

  useEffect(() => {
    if (!slot || initialized.current) return;

    try {
      window.adsbygoogle = window.adsbygoogle || [];
      window.adsbygoogle.push({});
      initialized.current = true;
    } catch {
      // Ad blockers and failed network requests must not break page rendering.
    }
  }, [slot]);

  // AdSense creates slot IDs in the publisher account. Never request an ad
  // with an invented or empty ID while the site is still being configured.
  if (!slot) return null;

  return (
    <aside
      className={`adsense-placement w-full overflow-hidden ${className}`}
      aria-label="Publicidade"
    >
      <span className="block mb-2 text-center text-[10px] uppercase tracking-widest text-foreground-400">
        Publicidade
      </span>
      <ins
        className="adsbygoogle block min-h-[90px]"
        style={{ display: 'block' }}
        data-ad-client={PUBLISHER_ID}
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </aside>
  );
}
